import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "../../UI/addForm.css";
import global from "../../config";
import Header from "../Header/Header";
import "./ManageShows.css";

export default function AddShow(props) {
  const [slug, setSlug] = useState("");
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [creatorID, setCreatorID] = useState("");
  const [description, setDescription] = useState("");
  const [editID, setEditID] = useState("");
  const [slugError, setSlugError] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [codeError, setCodeError] = useState(false);
  const [creatorIDError, setCreatorIDError] = useState(false);
  const [addUpdateError, setAddUpdateError] = useState("");
  const [addUpdateSuccess, setAddUpdateSuccess] = useState("");
  const [creatorsList, setCreatorsList] = useState([]);
  const [parent, setParent] = useState("");

  const navigate = useNavigate();
  const { showID } = useParams();

  const submitClick = async () => {
    if (slug.trim() === "") {
      setSlugError(true);
    }
    if (name.trim() === "") {
      setNameError(true);
    }

    const clearForm = () => {
      setSlug("");
      setName("");
      setCode("");
      setCreatorID("");
      setDescription("");
      setEditID("");
      setSlugError("");
      setNameError("");
      setAddUpdateError("");
      setAddUpdateSuccess("");
    };

    if (slugError === false) {
      const idToken = localStorage.getItem("idToken");

      const postPayload = {
        operation: "add",
        CreatorID: creatorID,
        ShowCode: code,
        ShowName: name,
        ShowSlug: slug,
        ShowDescription: description,
      };

      const editPayload = {
        operation: "edit",
        ShowName: name,
        ShowCode: code,
        ShowDescription: description,
      };

      if (editID === "") {
        try {
          const response = await axios.post(
            global.apiURL + "/shows",
            postPayload,
            { headers: { Authorization: "Bearer " + idToken } }
          );
          if (response) {
            setAddUpdateSuccess("Show added");
            setTimeout(clearForm, 2000);
          } else {
            console.log("Error");
          }
        } catch (e) {
          setAddUpdateError("Show already exists");
          console.log(e);
        }
      } else {
        try {
          const response = await axios.post(
            global.apiURL + "/shows",
            editPayload,
            { headers: { Authorization: "Bearer " + idToken } }
          );

          if (response) {
            setAddUpdateSuccess("Show Updated");
            setTimeout(clearForm, 2000);
          } else {
            console.log("Error");
          }
        } catch (e) {
          setAddUpdateError("Some error occured");
          console.log("Cannot update creator");
        }
      }
    } else {
      props.onActionAddError();
    }
  };

  const txtValue = (e) => {
    if (e.target.name === "txtCreator") {
      setCreatorID(e.target.value);
      if (e.target.value.trim() === "") {
        setCreatorIDError(true);
      } else {
        setCreatorIDError(false);
      }
    }

    if (e.target.name === "txtCode") {
      setCode(e.target.value);
      if (e.target.value.trim() === "") {
        setCodeError(true);
      } else {
        setCodeError(false);
      }
    }

    if (e.target.name === "txtName") {
      setName(e.target.value);
      if (e.target.value.trim() === "") {
        setNameError(true);
      } else {
        if (!showID) {
          setSlug(createSlug(e.target.value));
        }
        setNameError(false);
      }
    }
    if (e.target.name === "txtSlug") {
      setSlug(e.target.value);
      if (e.target.value.trim() === "") {
        setSlugError(true);
      } else {
        setSlugError(false);
      }
    }
    if (e.target.name === "txtDescription") {
      setDescription(e.target.value);
    }
  };

  const getCreators = async () => {
    const idToken = localStorage.getItem("idToken");
    const postPayload = { operation: "listShort" };
    const response = await axios.post(
      global.apiURL + "/creators",
      postPayload,
      { headers: { Authorization: "Bearer " + idToken } }
    );
    if (response.data) {
      setCreatorsList(response.data.data);
      console.log(response.data);
    }
  };

  function createSlug(text) {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-") // Replace spaces and special chars with hyphen
      .replace(/^-+|-+$/g, ""); // Remove leading and trailing hyphens
  }

  const getDetails = async () => {
    const idToken = localStorage.getItem("idToken");
    if (showID) {
      const payLoadShow = {
        operation: "search",
        searchCriteria: { _id: showID },
      };
      const respShow = await axios.post(
        global.apiURL + "/shows/",
        payLoadShow,
        {
          headers: { Authorization: "Bearer " + idToken },
        }
      );
      if (respShow.data.data.length > 0) {
        setParent(respShow.data.data[0].CreatorID);
        setName(respShow.data.data[0].ShowName);
        setCode(respShow.data.data[0].ShowCode);
        setSlug(respShow.data.data[0].ShowSlug);
        setDescription(respShow.data.data[0].ShowDescription);
        setEditID(respShow.data.data[0]._id);
      }
    }
  };

  useEffect(() => {
    getDetails();
    getCreators();
  }, []);

  return (
    <>
      <div class="wrap-over-container">
        <Header />

        <div className="admin-body">
          <div className="container">
            <div className="admin-panel">
              <div className="adheader-form">
                <h3>{showID ? "Edit" : "Add"} Show</h3>
                <div className="admin-panel-header-right">&nbsp;</div>

                <div className="adbody">
                  <span className="errorMsg">{addUpdateError}</span>
                  <span className="successMsg">{addUpdateSuccess}</span>

                  <div className="add-dialog-form-group">
                    <label>
                      Creator <span className="required">*</span>
                    </label>

                    <select
                      id="txtCreator"
                      name="txtCreator"
                      onChange={txtValue}
                      defaultValue={parent}
                      disabled={!!showID}
                    >
                      <option key="NA" value="">
                        Select Creator
                      </option>
                      {creatorsList.map((e) => (
                        <option
                          key={e._id}
                          value={e._id}
                          selected={e._id === parent}
                        >
                          {e.CreatorName}
                        </option>
                      ))}
                    </select>
                    {creatorID === true && (
                      <p className="error">Creator is required</p>
                    )}
                  </div>

                  <div className="add-dialog-form-group">
                    <label>
                      Show Code <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      onChange={txtValue}
                      name="txtCode"
                      id="txtCode"
                      placeholder="Enter Show Code"
                      value={code}
                      disabled={!!showID}
                    />
                    {codeError === true && (
                      <p className="error">Show code is required</p>
                    )}
                  </div>

                  <div className="add-dialog-form-group">
                    <label>
                      Show Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      onChange={txtValue}
                      name="txtName"
                      id="txtName"
                      placeholder="Enter Show name"
                      value={name}
                    />
                    {nameError === true && (
                      <p className="error">Show name is required</p>
                    )}
                  </div>

                  <div className="add-dialog-form-group">
                    <label>
                      Folder Slug <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      onChange={txtValue}
                      name="txtSlug"
                      id="txtSlug"
                      placeholder="Enter Folder Slug"
                      value={slug}
                      readOnly
                      disabled={!!showID}
                    />
                    {slugError === true && (
                      <p className="error">Folder Slugs is required</p>
                    )}
                  </div>

                  <div className="add-dialog-form-group">
                    <label>Show Decsription</label>
                    <input
                      type="text"
                      onChange={txtValue}
                      name="txtDescription"
                      id="txtDescription"
                      placeholder="Enter creator Description"
                      value={description}
                    />
                  </div>

                  <div className="add-dialog-footer">
                    <button
                      type="button"
                      className="add-dialog-submit"
                      onClick={submitClick}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <Footer /> */}
      </div>
    </>
  );
}
